import { formatBaht } from '@xver/utils/number';
import { IconCurrencyBaht } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ApplicationState } from '@xver/store';

const HERO_BLUE = '#3b82f6';

function WalletPattern() {
    return (
        <svg
            className="absolute -right-12 -top-10 w-105 h-105 opacity-[0.07] pointer-events-none select-none"
            viewBox="0 0 200 200"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <defs>
                <radialGradient id="topupHeroRadial" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" stopColor={HERO_BLUE} stopOpacity="1" />
                    <stop offset="100%" stopColor={HERO_BLUE} stopOpacity="0" />
                </radialGradient>
            </defs>
            <circle cx="100" cy="100" r="100" fill="url(#topupHeroRadial)" />
            <circle cx="100" cy="100" r="48" stroke={HERO_BLUE} strokeWidth="1.5" />
            <circle
                cx="100"
                cy="100"
                r="74"
                stroke={HERO_BLUE}
                strokeWidth="1.5"
                strokeDasharray="4 6"
            />
            <circle cx="100" cy="100" r="22" stroke={HERO_BLUE} strokeWidth="1.5" />
        </svg>
    );
}

export default function TopupHero() {
    const { t } = useTranslation('topup');
    const user = useSelector((state: ApplicationState) => state.auth.user);
    const credit = user?.credit ?? 0;

    const formatted = formatBaht(credit);

    return (
        <div
            className="relative w-full overflow-hidden rounded-md border-[0.5px] border-line p-6 lg:p-8"
            style={{ background: 'var(--wallet-hero-gradient)' }}
        >
            <WalletPattern />

            <div className="relative z-10 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
                <div className="flex flex-col gap-2">
                    <p className="text-sm text-fg/65">{t('hero.title')}</p>
                    <div className="flex items-center gap-1">
                        <span className="text-3xl font-bold tabular-nums text-fg leading-none lg:text-5xl">
                            {formatted}
                        </span>
                        <IconCurrencyBaht size={34} stroke={2.5} className="text-fg/80 mb-1" />
                    </div>
                    <p className="max-w-md text-sm text-fg/68">{t('hero.subtitle')}</p>
                </div>
            </div>
        </div>
    );
}
